import { Checkbox } from "@mantine/core";
import { IconGps } from "@tabler/icons-react";
import dayjs from "dayjs";
import { type ControllerRenderProps, type FieldValues } from "react-hook-form";
import { useSelector } from "src/redux/hooks";

interface Props {
  field: ControllerRenderProps<FieldValues, string>;
  unit: string;
}
const HistoryCell = ({ unit, field }: Props) => {
  const { uppercase } = useSelector(state => state.preferencesSlice);

  const uppercaseStyles = {
    textTransform: uppercase ? "uppercase" : "none",
  } as any;

  switch (unit) {
    case "check":
      return (
        <Checkbox icon={IconGps} size="lg" checked={field.value} disabled />
      );
    case "date":
      return (
        <p
          style={{
            fontWeight: 200,
            opacity: 0.5,
            textAlign: "center",
            ...uppercaseStyles,
          }}>
          {field.value ? dayjs(field.value).format("DD MMM YYYY") : ""}
        </p>
      );
    default:
      return (
        <p
          style={{
            fontWeight: 200,
            opacity: 0.5,
            textAlign: "center",
            ...uppercaseStyles,
          }}>
          {field.value}
        </p>
      );
  }
};
export default HistoryCell;
